"use client"

import React, {useMemo, useState} from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import PathsList from "@/components/PathsList/PathsList";
import styles from "./HomeScreen.module.scss";
import {PiHandsPraying} from "react-icons/pi";
import {useTranslations} from "use-intl";
import {FaHiking} from "react-icons/fa";
import {MdOutlineMobileScreenShare} from "react-icons/md";
import {Link} from "@/i18n/routing";
import useViewportState from "beautiful-react-hooks/useViewportState";
import usePlacesData from "@/utils/hooks/usePlacesData";
import {Place} from "@/types/Places";
import Image from "next/image";
import usePathsData from "@/utils/hooks/usePathsData";
import {Path} from "@/types/Paths";
import AddToHome from "@/components/AddToHome/AddToHome";
import {Chip, Stack} from "@mui/material";


const HomeScreen = () => {
  const t = useTranslations("Home")
  const {width} = useViewportState();
  // Random page calcolato una sola volta a mount via lazy state init:
  // useMemo non sarebbe sufficiente perche' la regola react-hooks/purity
  // tratta la factory di useMemo come parte del render. useState con
  // lazy initializer invece viene chiamato fuori dal render check.
  const [placesPage] = useState(() => String(Math.random() * 50))
  const data = usePlacesData({page_size: '5', page: placesPage})
  const paths = usePathsData()

  // I due array di nodi del carousel sono pura derivazione dai dati:
  // niente useState + useEffect, deriviamoli con useMemo.
  const items = useMemo<React.ReactNode[]>(() => {
    if (!data) return []
    return (data.items ?? []).map((i: Place) => (
      <div key={i.id} className={styles.carouselItem}>
        <Link href={'place/' + i.id}>
          <Image className={styles.carouselImage} fill unoptimized
                 src={i.images?.at(0) ? i.images?.at(0)?.url + '/640x480' : "/PLACEHOLDER-640x480px.jpg"}
                 alt={i.name}/>
        </Link>
        <div className={styles.carouselItemTitle}>
          <Link href={'place/' + i.id}>{i.name}</Link>
          <div>
            <Stack sx={{mt: 2, flexWrap: "wrap"}} spacing={2} direction={"row"}>
              {i.segments && i.segments.map((itm, key) => (
                <Link key={key} href={`/tappa/${itm.id}`}>
                  <Chip style={{color: "#fff", borderColor: "#fff"}} icon={<FaHiking/>} size={"small"}
                        label={itm.name}
                        color="info"
                        variant="outlined"/>
                </Link>
              ))}
            </Stack>
          </div>
        </div>
      </div>
    ))
  }, [data])

  const itemsPaths = useMemo<React.ReactNode[]>(() => {
    if (!paths) return []
    return (paths.items ?? []).map((i: Path) => (
      <div key={i.id} className={styles.carouselItem}>
        <Link href={'cammino/' + i.id}>
          <Image className={styles.carouselImage} fill unoptimized
                 src={i.images?.at(0) ? i.images?.at(0)?.url + '/640x480' : "/PLACEHOLDER-640x480px.jpg"}
                 alt={i.name}/>
        </Link>
        <div className={styles.carouselItemTitle}>
          <Link href={'cammino/' + i.id}>{i.name}</Link>
        </div>
      </div>
    ))
  }, [paths])

  const isMobile = width < 1000
  return (
    <div className={styles.container}>
      <AddToHome/>
      <div className={styles.carouselWrapper}>
        <AliceCarousel autoPlay
                       infinite
                       disableButtonsControls
                       mouseTracking
                       autoPlayInterval={3000}
                       items={itemsPaths}/>
      </div>
      <div className={styles.upperRow}>
        <Link href={`/walk`} className={styles.walkBtn}>
          <FaHiking size={100}/>
          <h3>{t('walk')}</h3>
        </Link>
        <Link href={`/pray`} className={styles.prayBtn}>
          <PiHandsPraying size={100}/>
          <h3>{t('pray')}</h3>
        </Link>
        <Link href={`/share`} className={styles.shareBtn}>
          <MdOutlineMobileScreenShare size={100}/>
          <h3>{t('share')}</h3>
        </Link>
      </div>
      <PathsList/>
      <div className={styles.carouselWrapper}>
        <AliceCarousel autoPlay
                       infinite
                       disableButtonsControls
                       mouseTracking
                       autoPlayInterval={3000}
                       items={items}/>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.btns}>
          <div className={styles.btnItem}>
            <FaHiking className={styles.iconPrimary} size={100}/>
            <div className={styles.numberPrimary}>9</div>
            <div className={styles.itmName}>{t('walks')}</div>
          </div>
          <div className={styles.btnItem}>
            <FaHiking className={styles.iconSecondary} size={100}/>
            <div className={styles.numberSecondary}>223</div>
            <div className={styles.itmName}>{t('segments')}</div>
          </div>
          <div className={styles.btnItem}>
            <FaHiking className={styles.iconSecondary} size={100}/>
            <div className={styles.numberSecondary}>786</div>
            <div className={styles.itmName}>{t('pilgrims')}</div>
          </div>
          <div className={styles.btnItem}>
            <FaHiking className={styles.iconPrimary} size={100}/>
            <div className={styles.numberPrimary}>+700</div>
            <div className={styles.itmName}>{t('poi')}</div>
          </div>
        </div>
        <iframe className={styles.liturgia} src={`/it/widgets/liturgia-ore${isMobile ? '/0' : '/1'}`}/>
      </div>
    </div>
  );
};

export default HomeScreen;
